import { LoaderAction } from '../types';

export const addLoadingFlag = (scope: string) => {
  return {
    type: LoaderAction.ADDING_TIME_LOADING,
    scope
  };
};

export const subLoadingFlag = (scope: string) => {
  return {
    type: LoaderAction.SUB_TIME_LOADING,
    scope
  };
};

export const changeMessageLoading = (scope: string, message: string) => {
  return {
    type: LoaderAction.CHANGE_MESSAGE_LOADING,
    scope,
    message
  };
};


